import { useEffect } from 'react'

import { Modal, Divider, Select, TextInput, useModalStackContext } from '@mantine/core'
import { useForm } from '@mantine/form'
import dayjs from 'dayjs'
import { zodResolver } from 'mantine-form-zod-resolver'
import { z } from 'zod'

import Button from 'src/components/Buttons/Button/Button'
import DateInput from 'src/components/Inputs/DateInput/DateInput'
import { NOT_INTERESTED_REASON_OPTIONS } from 'src/lib/notInterestedReason.utils'

const STACK_ID = 'not-interested-modal'

const NotInterestedModal = ({ onSave, onClose }) => {
  const stackCtx = useModalStackContext()

  // Mantine gap: Modal's stack-register useEffect has no cleanup, so
  // unmounting while opened leaks the stackId in Modal.Stack. Mirrors DeleteModal.
  useEffect(() => {
    return () => {
      if (stackCtx) {
        stackCtx.removeModal(STACK_ID)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const schema = z.object({
    notInterestedReason: z
      .union([z.string(), z.null()])
      .refine((val) => val !== null && val.trim().length > 0, {
        message: 'Reason is required',
      }),
    content: z.string().min(0).max(250),
  })
  const form = useForm({
    initialValues: {
      applicantStageDate: dayjs(),
      notInterestedReason: null,
      content: '',
    },
    validate: zodResolver(schema),
  })
  const handleSubmit = (values) => {
    // TODO: Include these fields
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onSave(values)
    onClose()
  }

  const reasons = NOT_INTERESTED_REASON_OPTIONS

  return (
    <Modal
      opened={true}
      onClose={onClose}
      classNames={{ title: 'text-lg font-bold' }}
      title="Not Interested"
      centered
      stackId={STACK_ID}
    >
      <form
        className="grid grid-cols-2 gap-4"
        onSubmit={form.onSubmit(handleSubmit)}
      >
        <DateInput
          label="Not Interested Date"
          value={form.values.applicantStageDate?.toDate?.() ?? form.values.applicantStageDate}
          onChange={(date) => form.setFieldValue('applicantStageDate', date)}
        />
        <Select
          label="Reason"
          placeholder="Select a reason"
          data={reasons}
          withAsterisk
          searchable
          {...form.getInputProps('notInterestedReason')}
        />
        <TextInput
          label="Notes"
          placeholder="Additional details or comments (optional)"
          className="col-span-2"
          {...form.getInputProps('content')}
        />
        <Divider className="col-span-2" />
        <Button text="Cancel" variant="outline" onClick={onClose} />
        <Button text="Save" type="submit" />
      </form>
    </Modal>
  )
}

export default NotInterestedModal
